import type { Data } from '@repo/strapi'
import { useState } from 'react'

export function useCollapsibleCategories(categories: Data.Component<'shared.roadmap-category'>[]) {
	const [openCategories, setOpenCategories] = useState<Record<string | number, boolean>>(() => {
		const initialState: Record<string | number, boolean> = {}
		categories.forEach((category) => {
			if (category?.id) {
				initialState[category.id] = true
			}
		})
		return initialState
	})

	const toggleCategory = (categoryId: string | number) => {
		setOpenCategories((prev) => ({
			...prev,
			[categoryId]: !prev[categoryId],
		}))
	}

	return { openCategories, toggleCategory }
}
